module.exports = __webpack_public_path__ + "img/sorceress_small.366b77b7.png";